import { useCallback } from 'react';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import { type VehicleListColumnKey } from '../../VehicleList';

type SortState = { columnKey: VehicleListColumnKey; sortingDirection: 'asc' | 'desc' } | null;

const useSetSortAsState = (
  sort: SortState,
  updateQueryParameterValues: UpdateQueryParameterValues,
): ((value: React.SetStateAction<SortState>) => void) => {
  const setSort = useCallback(
    (value: SortState): void => {
      if (value) {
        updateQueryParameterValues({
          filterKeys: { sortColumn: [value.columnKey], sortDir: [value.sortingDirection] },
        });
      } else {
        updateQueryParameterValues({
          filterKeys: { sortColumn: [], sortDir: [] },
        });
      }
    },
    [updateQueryParameterValues],
  );

  return useCallback(
    (value: React.SetStateAction<SortState>): void => {
      const next = typeof value === 'function' ? value(sort) : value;
      setSort(next);
    },
    [sort, setSort],
  );
};

export default useSetSortAsState;
